import { useUpdate } from '@lib/systems/update'
import { useState } from '@lib/systems/state'
import { useUi, LABEL, BUTTON } from '@lib/systems/ui'
import { LEFT_BUTTON } from '@lib/systems/mouseInput'
import { useDebugRenderer } from '@lib/renderers/debug'
import makeLayout from '@lib/util/layout'

import setBoard from '@game/util/setBoard'
import { boards } from '@game/boards'
import { COMPUTER } from '@game/constants'
import { findMatch, UNRANKED } from '@game/util/network'

let res

function wrapLayout (cvs, layout) {
  layout.items = layout.items.map((item) => {
    if (!item.width) item.width = cvs.width * 0.15
    if (!item.height) item.height = cvs.height * 0.07
    return item
  })
  return makeLayout(layout)
}

function displayLayout (uiCtx, layout) {
  layout.forEach(item => {
    if (item.kind === undefined) return
    res = (item.kind === LABEL ? uiCtx.label : uiCtx.button)(item) // eslint-disable-line
    if (res && res.pressed === LEFT_BUTTON) {
      if (item.scene) uiCtx.state.currentScene = item.scene
      if (item.callback) item.callback()
    }
  })
}

export default function () {
  const state = useState()

  const uiContext = useUi()
  const { state: uiState } = uiContext
  uiState.currentScene = 'multiplayerMenu'

  const [, canvas] = useDebugRenderer()

  useUpdate(function () {
    if (uiState.currentScene === 'title') {
      displayLayout(uiContext, wrapLayout(canvas, {
        items: [
          {
            kind: LABEL,
            text: 'POMS'
          },
          {
            height: 0
          },
          {
            kind: BUTTON,
            text: 'Singleplayer',
            scene: 'singleplayerMenu'
          },
          {
            kind: BUTTON,
            text: 'Multiplayer',
            scene: 'multiplayerMenu'
          },
          {
            kind: BUTTON,
            text: 'Settings',
            scene: 'settings'
          }
        ],
        x: 0,
        y: 0,
        width: canvas.width,
        height: canvas.height,
        margin: canvas.width * 0.015,
        anchors: '',
        direction: 'column'
      }))
    }

    else if (uiState.currentScene === 'settings') {
      displayLayout(uiContext, wrapLayout(canvas, {
        items: [
          {
            kind: LABEL,
            text: 'Settings'
          },
          {
            height: 0
          },
          {
            kind: BUTTON,
            text: 'Return',
            scene: 'title'
          }
        ],
        x: 0,
        y: 0,
        width: canvas.width,
        height: canvas.height,
        margin: canvas.width * 0.015,
        anchors: '',
        direction: 'column'
      }))
    }

    else if (uiState.currentScene === 'singleplayerMenu') {
      displayLayout(uiContext, wrapLayout(canvas, {
        items: [
          {
            kind: LABEL,
            text: 'Single Player'
          },
          {
            height: 0
          },
          // {
          //   kind: BUTTON,
          //   text: 'Arcade',
          //   scene: 'arcadeMenu'
          // },
          {
            kind: BUTTON,
            text: 'Versus',
            scene: 'versusMenu'
          },
          {
            kind: BUTTON,
            text: 'Return',
            scene: 'title'
          }
        ],
        x: 0,
        y: 0,
        width: canvas.width,
        height: canvas.height,
        margin: canvas.width * 0.015,
        anchors: '',
        direction: 'column'
      }))
    }

    // else if (uiState.currentScene === 'arcadeMenu') {
    //   displayLayout(uiContext, wrapLayout(canvas, {
    //     items: [
    //       {
    //         kind: LABEL,
    //         text: 'Arcade Mode'
    //       },
    //       {
    //         height: 0
    //       },
    //       {
    //         kind: BUTTON,
    //         text: 'New Game',
    //         scene: 'game'
    //       },
    //       {
    //         kind: BUTTON,
    //         text: 'Return',
    //         scene: 'singleplayerMenu'
    //       }
    //     ],
    //     x: 0,
    //     y: 0,
    //     width: canvas.width,
    //     height: canvas.height,
    //     margin: canvas.width * 0.015,
    //     anchors: '',
    //     direction: 'column'
    //   }))
    // }

    // else if (uiState.currentScene === 'arcadeProgress') {

    // }

    // else if (uiState.currentScene === 'arcadeWin') {

    // }

    // else if (uiState.currentScene === 'arcadeLose') {

    // }

    else if (uiState.currentScene === 'versusMenu') {
      displayLayout(uiContext, wrapLayout(canvas, {
        items: [
          {
            kind: LABEL,
            text: 'Versus Mode'
          },
          {
            height: 0
          },
          {
            kind: BUTTON,
            text: 'New Game',
            scene: 'game',
            callback () {
              setBoard({
                board: boards[0],
                opponentMode: COMPUTER,
                opponentDifficulty: 0
              })
            }
          },
          {
            kind: BUTTON,
            text: 'Return',
            scene: 'singleplayerMenu'
          }
        ],
        x: 0,
        y: 0,
        width: canvas.width,
        height: canvas.height,
        margin: canvas.width * 0.015,
        anchors: '',
        direction: 'column'
      }))
    }

    else if (uiState.currentScene === 'versusRematch') {
      displayLayout(uiContext, wrapLayout(canvas, {
        items: [
          {
            kind: LABEL,
            text: 'Game Over'
          },
          {
            kind: LABEL,
            text: `Player ${state.board.winner} wins.`
          },
          {
            height: 0
          },
          {
            kind: BUTTON,
            text: 'Rematch',
            scene: 'game',
            callback () {
              setBoard({
                board: boards[0],
                opponentMode: COMPUTER,
                opponentDifficulty: 0
              })
            }
          },
          {
            kind: BUTTON,
            text: 'Return',
            scene: 'singleplayerMenu'
          }
        ],
        x: 0,
        y: 0,
        width: canvas.width,
        height: canvas.height,
        margin: canvas.width * 0.015,
        anchors: '',
        direction: 'column'
      }))
    }

    else if (uiState.currentScene === 'multiplayerMenu') {
      displayLayout(uiContext, wrapLayout(canvas, {
        items: [
          {
            kind: LABEL,
            text: 'Multiplayer'
          },
          {
            height: 0
          },
          {
            kind: BUTTON,
            text: 'Find Match',
            scene: 'game',
            async callback () {
              findMatch({
                host: 'http://localhost:3000',
                kind: UNRANKED
              })
            }
          },
          {
            kind: BUTTON,
            text: 'Return',
            scene: 'title'
          }
        ],
        x: 0,
        y: 0,
        width: canvas.width,
        height: canvas.height,
        margin: canvas.width * 0.015,
        anchors: '',
        direction: 'column'
      }))
    }

    else if (uiState.currentScene === 'mpVersusMenu') {

    }

    else if (uiState.currentScene === 'unrankedMenu') {

    }

    else if (uiState.currentScene === 'rankedMenu') {

    }

    else if (uiState.currentScene === 'mpRematch') {

    }

    else if (uiState.currentScene === 'networkLoading') {

    }

    else if (uiState.currentScene === 'opponentDisconnected') {

    }

    else if (uiState.currentScene === 'networkDisconnected') {

    }

    else if (uiState.currentState === 'board') {

    }
  })
}
